import integralIndex from '@/pages/integral/index.vue'
import integralList from '@/pages/integral/integralList.vue'
import integralDetail from '@/pages/integral/integralDetail.vue'
import integralOrderDetail from '@/pages/integral/integralOrderDetail.vue'
import integralOrderList from '@/pages/integral/integralOrderList.vue'

const appRoutes = [{
	path: '/integral',
	redirect: '/integral/integralList',
	component: integralIndex,
	children: [{
		path: 'integralList',
    name: 'integralList',
		component: integralList
	},{
		path: 'integralDetail',
    name: 'integralDetail',
		component: integralDetail
	},{
		path: 'integralOrderDetail',
    name: 'integralOrderDetail',
		component: integralOrderDetail
	},{
		path: 'integralOrderList',
    name: 'integralOrderList',
		component: integralOrderList
	}]
}]
export default appRoutes

